import type { FC, ReactNode } from 'react'

import { contributorToPickerItem, fetchContributors } from './contributorsAutocompleteShared'

import type {
  ChakraAsyncCreatableSelectProps,
  ReactSelectAutocompleteValue
} from '@app/shared/autocomplete/chakraAutocompletes'
import { ChakraAsyncCreatableSelect } from '@app/shared/autocomplete/chakraAutocompletes'
import type { Contributor } from '@graphql/queries'

interface ContributorObject {
  id: string | number
  contributor: Contributor
}

interface Props extends Partial<Omit<ChakraAsyncCreatableSelectProps<ReactSelectAutocompleteValue[]>, 'defaultValue'>> {
  defaultValue?: ContributorObject[]
}

interface OptionData extends ReactSelectAutocompleteValue {
  sourceName: string
}

const ContributorsAutocomplete: FC<Props> = ({ defaultValue = [], onChange = () => {}, ...rest }) => {
  // Append sourceName: 'email' on to the normal option set for new options
  const getNewOptionData = (inputValue: string, optionLabel: ReactNode): OptionData[] => [
    {
      value: inputValue,
      label: optionLabel.toString(),
      sourceName: 'email'
    }
  ]

  // Generic Email Validation
  const isValidNewOption = (inputValue) => /^[^@\s]+@[^@\s.]+\.[^@.\s]+$/.test(inputValue)

  // Instead of Create "X" it shows Add "X"
  const formatCreateLabel = (inputValue) => `Add ${inputValue}`

  return (
    <ChakraAsyncCreatableSelect<ReactSelectAutocompleteValue[]>
      aria-label="contributors-autocomplete"
      asyncFetch={(inputValue) => fetchContributors(inputValue)}
      placeholder="Add a contributor"
      noOptionsMessage="Start typing to find a contributor or type an email to add one"
      formatCreateLabel={formatCreateLabel}
      getNewOptionData={getNewOptionData}
      onChange={onChange}
      isValidNewOption={isValidNewOption}
      initialValues={defaultValue?.map(contributorToPickerItem) || []}
      {...rest}
    />
  )
}

export default ContributorsAutocomplete
